import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';

// Pages
import home from './pages/home';
import personal from './pages/personalInformation';
import contact from './pages/contact';
import skills from './pages/skills';
import work from './pages/work';
import TrackBillPrivacy from './pages/TrackBillPrivacy';
import Navbar from './components/Navbar';
import WorkItemDetail from './components/WorkItemDetail';
import axios from 'axios';

// Redux
import { Provider } from 'react-redux';
import Store from './redux/store';

axios.defaults.baseURL = 'https://europe-west3-laurenz-portfolio.cloudfunctions.net/api';

class App extends Component {
  render() {
    return (
      <Provider store={Store}>
        <div className="App">
        <Router>
          <Navbar/>
          <div className="container">
            <Switch>
              <Route exact path="/" component={home}/>
              <Route exact path="/personal/" component={personal}/>
              <Route exact path="/contact/" component={contact}/>
              <Route exact path="/skills/" component={skills}/>
              <Route exact path="/work/" component={work}/>
              <Route exact path="/work/:title/" component={WorkItemDetail}/>
              <Route exact path="/work/TrackBill/privacy" component={TrackBillPrivacy}/>
            </Switch>
          </div>
          {/* <footer className="MainFooter">
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" 
              target="_blank"/>
              <ul>
                <li><a href="https://www.facebook.com/lori.hill.9465/" target="_blank">
                  <i className="fa fa-facebook"/>
                </a></li>
  
                <li><a href="https://twitter.com/HillLaurenz" target="_blank">
                  <i className="fa fa-twitter"/>
                </a></li>
  
                <li><a href="https://www.instagram.com/isendegal/" target="_blank">
                  <i className="fa fa-instagram"/>
                </a></li>
  
                <li><a href="https://www.linkedin.com/in/laurenz-hill-5b3b93195/" target="_blank">
                  <i className="fa fa-linkedin"/>
                </a></li>
  
                <li><a href="https://github.com/Laurenz1308" target="_blank">
                  <i className="fa fa-github"/>
                </a></li>
              </ul>
            </footer> */}
        </Router>
      </div>
      </Provider>
    );
  };
}

export default App;
